const priceFormatter = new Intl.NumberFormat();

export default priceFormatter;
